import { ApiService } from "../../../config";
import { handleError } from "@/utils/parseApiReturn";

const defaultRoute = "/configs";

type TConfig = {
  id: number;
  userId: number;
  contactEmail: string;
  createdAt: string;
  updatedAt: string;
  webhookUrl: string;
  webhookActive: boolean;
  webhookToken: string;
};

interface IResponseData {
  success: boolean;
  data?: TConfig;
}

interface IRequestUpdateEmailConfig {
  contactEmail: string;
}

const getConfig = async (): Promise<IResponseData> => {
  try {
    const res = await ApiService.get(defaultRoute);
    return {
      success: true,
      data: res.data.data
    };
  } catch (error: unknown) {
    return handleError(error, "Erro na requisição para obter email:");
  }
};

const updateEmailConfig = async ({
  contactEmail
}: IRequestUpdateEmailConfig): Promise<IResponseData> => {
  try {
    const res = await ApiService.patch(defaultRoute, { contactEmail });
    return { success: true, data: res.data.data };
  } catch (error: unknown) {
    return handleError(error, "Erro ao atualizar para obter email:");
  }
};

const updateWebhookConfig = async (
  webhookUrl: string,
  webhookToken: string,
  webhookActive: boolean
) => {
  try {
    const res = await ApiService.patch(defaultRoute, {
      webhookUrl,
      webhookToken,
      webhookActive
    });
    return { success: true, data: res.data.data };
  } catch (error: unknown) {
    return handleError(error, "Erro ao atualizar o webhook:");
  }
};

export const ConfigService = {
  getConfig,
  updateEmailConfig,
  updateWebhookConfig
};
